import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";
import EmissionAmbienteSync from "components/sync/EmissionAmbienteSync";
import { useIdioma } from "stores/idiomaStore";

function AdminLayout(props) {
  const { ...rest } = props;
  const location = useLocation();
  const { t } = useIdioma();
  const [open, setOpen] = React.useState(true);
  const [rutaActiva, setRutaActiva] = React.useState(null);

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);

  const getActiveRoute = React.useCallback(() => {
    const pathname = location.pathname;
    const adminHits = routes.filter(
      (r) =>
        r.layout === "/admin" &&
        r.path &&
        pathname.includes(`${r.layout}/${r.path}`)
    );
    adminHits.sort((a, b) => (b.path?.length || 0) - (a.path?.length || 0));
    setRutaActiva(adminHits.length > 0 ? adminHits[0] : null);
  }, [location.pathname]);

  React.useEffect(() => {
    getActiveRoute();
  }, [getActiveRoute]);

  const getActiveNavbar = (routes) => {
    const pathname = location.pathname;
    const adminHits = routes.filter(
      (r) =>
        r.layout === "/admin" &&
        r.path &&
        pathname.includes(`${r.layout}/${r.path}`)
    );
    adminHits.sort((a, b) => (b.path?.length || 0) - (a.path?.length || 0));
    return adminHits[0]?.secondary ?? false;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <EmissionAmbienteSync />
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              brandText={
                rutaActiva?.claveI18n
                  ? t(rutaActiva.claveI18n, rutaActiva.name)
                  : rutaActiva?.name || t("menu.dashboard", "Main Dashboard")
              }
              secondary={getActiveNavbar(routes)}
              {...rest}
            />
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(routes)}

                <Route
                  path="/"
                  element={<Navigate to="/admin/default" replace />}
                />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default function Admin(props) {
  return <AdminLayout {...props} />;
}
